var React = require('react');

function FooterLogoInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M133.325 1H1.6748V97H133.325V1Z","stroke":"white","strokeWidth":"1.5","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"M39.0294 36.9807V60.9807H36.9422L21.6229 41.5118V60.9807H19.0186V36.9807H21.125L36.5592 56.4495V36.9807H39.0294Z","fill":"white","key":1}),React.createElement("path",{"d":"M56.8186 36.9807H59.4229V60.9807H56.8952L56.8186 36.9807Z","fill":"white","key":2}),React.createElement("path",{"d":"M115.954 36.9807V60.9807H113.867L98.5478 41.5118V60.9807H96.0201V36.9807H98.1075L113.427 56.4495V36.9807H115.954Z","fill":"white","key":3}),React.createElement("path",{"d":"M76.1638 36.9807H78.6915V60.9807H76.1638V36.9807Z","fill":"white","key":4})]);
}

FooterLogoInline.defaultProps = {"width":"135","height":"98","viewBox":"0 0 135 98","fill":"none"};

module.exports = FooterLogoInline;

FooterLogoInline.default = FooterLogoInline;
